import moment from "moment";
import { actionTypes, Types } from "../../context/action/action";
import store from "../../context/store/store";
import { chats, chatwindowDetails, contactwindowDetails, UserDetails } from "../../models/model";
import { toastInformation } from "../callService/common";
import { savedChatListFraming, userInfo } from "./utils";
import { openChatWindowRedux, openContactWindowRedux, setAllContact, setTeamContactNew,chatNotificationFlow } from "./newChat";
import _ from 'lodash';
import { mp3Formats, videoFormat, ConvertDuration, tempPushNotification, newTagUnread, playNotificationSound } from "../utils";

export const newGroupChat = (socket: any, message: any) => {
    let chatwindowDetails: any = store.getState().chatWindowReducer?.chatWindowDetails;
    let {scrollUnread,countValue}:chats=store.getState().chatReducer;
    let unreadCount_value = countValue+1;
    if (chatwindowDetails && message && (chatwindowDetails.chatId || chatwindowDetails.team_id )&& message.chatId) {
        if((chatwindowDetails?.chatId?.toString() === message?.chatId?.toString()) || (chatwindowDetails?.team_id?.toString() === message?.chatId?.toString()) )
        {
            if(scrollUnread)
            {
                store.dispatch({
                    type: Types.COUNT_VALUE,
                    payload:{
                        countValue:unreadCount_value
                    }
                
                })
            }
        }
    }
   
    try {
    let { messageList,messageExtraList }: any = store.getState().chatSocketReducerState;
    let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let contactObject: any = store.getState().contactReducer;
    let teamContact = contactObject?.teamContacsnew;
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    const userDetailsnew = userInfo();
    const currUser = parseInt(userDetailsnew.fromID);
    const recentID = parseInt(message.from) !== currUser ? message.from : parseInt(message.to) !== currUser ? message.to : "";
    const fromUser = parseInt(message.from);
    const archiveMessage = [...messageList];
    const archiveExtraMessage = [...messageExtraList];
    let direction = '';
    const unixTimeStamp = moment().valueOf();
    const msgFrom = parseInt(message.from);
    let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
    let who = '';
    if (msgFrom === parseInt(loggedUserDetails.sip_login_id)) {
        who = 'You';
    } else {
        const fromCaller = contactObject.workContactsnew[fromUser];
        who = fromCaller?.caller_id;
    }
    let finalString = '';
  
      const members = message?.message?.teamAction?.members.toString().split(',');
        const finalMembers:any = Array.isArray(members) && members?.length > 0 && members.map((value: any) => {
        if (_.isUndefined(contactObject.workContactsnew[value]) === false) {
            const userD = contactObject.workContactsnew[value];
            return userD?.caller_id;
        } else {
            return []
        }
    });
    if (message?.message?.teamAction?.actionKey === "create_group") {
        finalString = who + ' ' + finalString + message?.message?.teamAction?.description;
    } else if (message?.message?.teamAction?.actionKey === "remove_member") {
        finalString = who + " removed " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "add_member") {
        finalString = who +  " added " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "make_admin") {
        finalString = who +  " make as admin " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "make_member") {
        finalString = who + " make as member " + message?.message?.teamAction?.description + finalMembers.join();
    } else if (message?.message?.teamAction?.actionKey === "leave_member") {
        finalString = who + " left the group " + message?.message?.teamAction?.description + finalMembers.join();
    } else {
        finalString = who + ' ' + finalString + message?.message?.teamAction?.description + finalMembers;
    }
    const audio = new Audio(message?.message?.body?.filePath); 

    let lastMesgText = message?.message?.messageType === "TEXT" ? message?.message.body :
     message?.message?.messageType === "FILE" && videoFormat.indexOf(message?.message?.body?.fileType) !== -1
                ? "Video" :
        message?.message?.messageType === "FILE" && videoFormat.indexOf(message?.message?.body?.fileType) === -1 ? "Shared a file" :  message?.message?.messageType === "IMAGE" && message?.message?.body?.fileType?.includes("gif")
        ? "GIF"
        : message?.message?.messageType === "IMAGE" ? "IMAGE" :
            message?.message?.messageType === "NOTE" ? "Shared a notes" : message?.message?.messageType === "TASK" ?
                "Shared a task" : message?.message?.messageType === "EVENTS" ? "Shared a event" : message?.message?.messageType === "BROADCAST" ? finalString : "";
    //const msgto = message.to.split(',');
    if (msgFrom !== parseInt(userInfo().fromID)) {
        socket.groupChatDelivered(message.id, 2, unixTimeStamp, message.from.toString(), message.chatId, message.chatId);
        if (parseInt(message.chatId) === parseInt(chatWindowReducer?.chatWindowDetails?.team_id)) {
            if (document.visibilityState === "visible" && window.location.pathname === '/chats') {
                //console.log("tab receivechat group active");
                socket.groupChatReadStatus(message.id, 2, unixTimeStamp, message.from.toString(), message.chatId, message.chatId);
            } else {
              //console.log("tab receivechat group inactive");
              if (recentChatList["con" + message.chatId]) {
                const unreadCount = (recentChatList["con" + message.chatId]?.unreadCount) !== 0
                    && (recentChatList["con" + message.chatId]?.unreadCount) > 0
                    ? parseInt(recentChatList["con" + message.chatId]?.unreadCount) + 1 : 1;
                recentChatList["con" + message.chatId].unreadCount = unreadCount;
            }
              const teamContact:any =  contactObject.teamContacsnew?.["con"+message?.chatId]; 
           
            
              const fromCaller = contactObject.workContactsnew?.[fromUser];
              let fromUserInfo:any = contactObject.workContactsnew[recentID];
              let inputOptions = {
                userName: _.upperFirst(teamContact.team_name) ,
                message: message,
                id: fromUserInfo && fromCaller,
                GroupId:teamContact
            };
            if(document.visibilityState === "visible" && window.location.pathname !== '/chats'){
                playNotificationSound()
            }else{
                chatNotificationFlow(inputOptions,'');
            }
            }
        } else {
            if (recentChatList["con" + message.chatId]) {
                const unreadCount = (recentChatList["con" + message.chatId]?.unreadCount) !== 0
                    && (recentChatList["con" + message.chatId]?.unreadCount) > 0
                    ? parseInt(recentChatList["con" + message.chatId]?.unreadCount) + 1 : 1;
                recentChatList["con" + message.chatId].unreadCount = unreadCount;
            }
            const fromCaller = contactObject.workContactsnew?.[fromUser];
            const teamContact =  contactObject.teamContacsnew?.["con"+message?.chatId];  
            if (message?.message?.teamAction?.actionKey === "remove_member") {
                let team = teamContact?.team_members.split(',')
                let splitteam:any =  _.indexOf(teamContact?.team_members.split(','), message?.message?.teamAction?.members );
                let members = team.splice(0,splitteam)?.toString()
                 teamContact['team_members'] = members
            }     
               
            let teamMemberMuted = teamContact?.team_members_muted ? teamContact?.team_members_muted.split(",").map((ele: any) => ele.trim()): [];
            let currentTeamMember = Array.isArray(teamMemberMuted) && teamMemberMuted?.length>0 ? teamMemberMuted.map((value:any)=> value.split('_')[0]):[];
            let currentTimeTeam = Array.isArray(teamMemberMuted) && teamMemberMuted?.length>0 ? teamMemberMuted.map((value:any)=> value.split('_')[1]):[];
            var currentTimestamp = moment().valueOf();
            var currentTimeTeamStamp = currentTimeTeam.toString();
            let fromUserInfo:any = contactObject.workContactsnew[recentID];
            if (fromCaller && message?.chatId && Array.isArray(currentTeamMember) 
            && currentTeamMember?.indexOf(userInfo().fromID)>-1 && currentTimeTeam
            && currentTimestamp<parseInt(currentTimeTeamStamp)) {
            } else {
                let teamMemberMuted = teamContact?.team_members_muted ? teamContact?.team_members_muted.split(",").map((ele: any) => ele.trim()) : [];
                let currentTeamMember = Array.isArray(teamMemberMuted) && teamMemberMuted.length > 0 ? teamMemberMuted.map((value: any) => value.split('_')[0]) : [];
                let muteNotify = currentTeamMember?.length > 0 && _.includes(currentTeamMember,loggedUserDetails?.sip_login_id)
                if(!muteNotify){
                if (document.visibilityState === "visible") {
                    if((mp3Formats.indexOf(message?.message?.body?.fileType) !== -1 || videoFormat.indexOf(message?.message?.body?.fileType) !== -1) && message?.message?.messageType === "FILE"){
                        audio.addEventListener("loadedmetadata", function () {
                            const fromCaller = contactObject.workContactsnew[recentID];
                            let duration_set=ConvertDuration(audio.duration);
                            //console.log('duration with audio ---->', duration_set);
                            let inputOptions = {
                                userName: _.upperFirst(teamContact?.team_name) ,
                                message: message,
                                id: fromUserInfo && fromCaller,
                                GroupId:teamContact
                            };
                            chatNotificationFlow(inputOptions,duration_set);
                            //return ConvertDuration(duration_audio);
                        });
                    }else {
                    let inputOptions = {
                        userName: _.upperFirst(teamContact?.team_name) ,
                        message: message,
                        id: fromUserInfo && fromCaller,
                        GroupId:teamContact
                    };
                    playNotificationSound();
                   // chatNotificationFlow(inputOptions,'');
                    }
                }else {
                    const fromCaller = contactObject.workContactsnew[recentID];
                    let inputOptions = {
                        userName: _.upperFirst(teamContact?.team_name) ,
                        message: message,
                        id: fromUserInfo && fromCaller,
                        GroupId:teamContact
                    };
                    chatNotificationFlow(inputOptions,'');
                }
            }
            }
        }
    }
    if (recentChatList["con" + message.chatId]) {
        message["lastmsgText"] = lastMesgText;
        recentChatList["con" + message.chatId].lastmessage = message;
    }

    if (message.type === 2) {
        message.teammembersdetails = teamContact["con" + message.chatId]?.team_members?.replace(/\s/g, '').split(',').map((value: any) => {
            return contactObject.workContactsnew[parseInt(value)];
        })

    }
    message["lastmsgText"] = lastMesgText;



    if (message.type === 2) {
        message.teammembersdetails = teamContact["con" + message.chatId]?.team_members?.replace(/\s/g, '').split(',').map((value: any) => {
            return contactObject.workContactsnew[parseInt(value)];
        })

    }
    let initialObj ={};

    if (_.isUndefined(recentChatList["con" + message.chatId])
    && parseInt(chatWindowReducer?.chatWindowDetails?.team_id) === parseInt(message?.chatId)) {
        initialObj = {
            chatId: message.chatId,
            createdAt: new Date().toISOString(),
            from: message.from,
            id: message.id,
            lastmsgText: lastMesgText,
            to: message.to,
            timestamp: message.timestamp,
            lastmessage: message,
            type: message.type,
            updatedAt: new Date().toISOString(),
            unreadCount: 0
        };
        recentChatList["con" + message.chatId] = initialObj;
    } else if (_.isUndefined(recentChatList["con" + message.chatId])
    && parseInt(chatWindowReducer?.chatWindowDetails?.team_id) !== parseInt(message?.chatId)) { 
        initialObj = {
            chatId: message.chatId,
            createdAt: new Date().toISOString(),
            from: message.from,
            id: message.id,
            lastmsgText: lastMesgText,
            to: message.to,
            timestamp: message.timestamp,
            lastmessage: message,
            type: message.type,
            updatedAt: new Date().toISOString(),
            unreadCount: msgFrom === parseInt(loggedUserDetails.sip_login_id) ? 0 : 1
        };
        recentChatList["con" + message.chatId] = initialObj;
    }


    const recentChatUser = recentChatList["con" + message.chatId];
    if (recentChatUser) {
        recentChatUser["lastmsgText"] = lastMesgText;
        recentChatUser["lastmessage"] = message;
        const settings = _.isUndefined(recentChatUser?.settings);
        if (settings) {
            recentChatUser.settings = {};
        }

        const isPinned = _.isUndefined(recentChatUser?.settings?.isPinned);
        const isArchived = _.isUndefined(recentChatUser?.settings?.isArchive);
        const isDeleted = _.isUndefined(recentChatUser?.settings?.isDeleted);
        const isMuted = _.isUndefined(recentChatUser?.settings?.isMuted);
        const isFavourited = _.isUndefined(recentChatUser?.settings?.isFavourite);
        const isMarkRead = _.isUndefined(recentChatUser?.settings?.markRead);
        if (isPinned) {
            recentChatUser.settings.isPinned = {};
        }
        if (isArchived) {
            recentChatUser.settings.isArchive = {};
        }
        if (isDeleted) {
            recentChatUser.settings.isDeleted = {};
        }
        if (isMuted) {
            recentChatUser.settings.isMuted = {};
        }
        if (isFavourited) {
            recentChatUser.settings.isFavourite = {};
        }
        if (isMarkRead) {
            recentChatUser.settings.markRead = {};
        }
        const fromID = parseInt(userInfo().fromID);
        const isPinnedParticipant = _.isUndefined(recentChatUser?.settings?.isPinned?.["s" + fromID]);
        const isArchivedParticipant = _.isUndefined(recentChatUser?.settings?.isArchive?.["s" + fromID]);
        const isDeletedParticipant = _.isUndefined(recentChatUser?.settings?.isDeleted?.["s" + fromID]);
        const isFavouriteParticipant = _.isUndefined(recentChatUser?.settings?.isFavourite?.["s" + fromID]);
        const isMutedParticipant = _.isUndefined(recentChatUser?.settings?.isMuted?.["s" + fromID]);
        const isMarkedParticipant = _.isUndefined(recentChatUser?.settings?.markRead?.["s" + fromID]);
        if (isPinnedParticipant) {
            recentChatUser.settings.isPinned["s" + fromID] = 0;
        }
        if (isArchivedParticipant) {
            recentChatUser.settings.isArchive["s" + fromID] = 0;
        }
        if (isDeletedParticipant) {
            recentChatUser.settings.isDeleted["s" + fromID] = 0;
        }
        if (isFavouriteParticipant) {
            recentChatUser.settings.isFavourite["s" + fromID] = 0;
        }
        if (isMutedParticipant) {
            recentChatUser.settings.isMuted["s" + fromID] = 0;
        }
        if (isMarkedParticipant) {
            recentChatUser.settings.markRead["s" + fromID] = 0;
        }
        if (recentChatUser.settings.isDeleted["s" + fromID] === 1) {
            recentChatUser.settings.isDeleted["s" + fromID] = 0;
        }
    }
    if (recentChatList["con" + message.chatId]) {
        recentChatList["con" + message.chatId] = recentChatUser;
        recentChatList["con" + message.chatId].lastmessage = message;
        recentChatList["con" + message.chatId].timestamp = message.timestamp;
    }
    store.dispatch({
        type: actionTypes.RECENT_MESSAGE_LIST,
        payload: {
            recentChatList: recentChatList,
            recentLoading: true
        }
    });
    if (fromUser !== parseInt(userInfo().fromID)) {
        direction = "IN";
    } else {
        direction = "OUT";
    }
    message.direction = direction;
    message.fromcaller_details = contactObject.workContactsnew[fromUser];
    if (_.isUndefined(message.deliveryStatus)) {
        message.deliveryStatus = 4;
        message.readStatus = 0;
    }
    if (parseInt(chatWindowReducer.chatWindowDetails.team_id) === parseInt(message.chatId)) {
        let parse: any = (message?.message?.messageType === "TASK" || message?.message?.messageType === "EVENTS") ? JSON.stringify(message?.message?.body) : "";
        let msg: any = message?.message?.messageType === "NOTE" ? message?.message?.body : (message?.message?.messageType === "TASK" || message?.message?.messageType === "EVENTS") ?
            JSON.parse(parse) : message.message.body;
        message.message.body = msg;
        archiveMessage.push(message);
        if(chatWindowReducer?.fileOpenMessage){
            archiveExtraMessage.push(message);
        }
        if(chatWindowReducer?.fileOpenMessage){
            
            store.dispatch({
                type: actionTypes.MESSAGE_EXTRALIST,
                payload:{
                    messageExtraList:archiveExtraMessage
                }
            })
        } else {
        store.dispatch({
            type: actionTypes.MESSAGE_LIST,
            payload: {
                messageList: archiveMessage,
                messageLoading: false
            }
        });
        }
    }
    if (message?.message?.isLink && chatWindowReducer.chatWindowDetails.team_id) {
        let chatRightSidePanelReducer: any = { ...store.getState().chatRightSidePanelReducer };
        const linksArray = [...chatRightSidePanelReducer.linkListDetails];
        message.chatId = message.chatId.toString();
        const linklistMessage = savedChatListFraming(message);
        linksArray.push(linklistMessage);
        store.dispatch({
            type: Types.GET_LINK_LIST,
            payload: {
                isLink: true,
                linkListDetails: linksArray
            }
        });
    }
    let chatRightSidePanelReducer: any = { ...store.getState().chatRightSidePanelReducer };
    if (message?.message?.messageType === "FILE" || message?.message?.messageType === "IMAGE") {
        const fileListDetails = [...chatRightSidePanelReducer.fileListDetails];
        fileListDetails.push(message);
        store.dispatch({
            type: Types.GET_FILES_LIST,
            payload: {
                isfile: true,
                fileListDetails: fileListDetails

            }
        });
    }
    if (message?.message?.messageType === "AT_MENTION" || message?.message?.isReply === true){
        tempPushNotification(message);
    }
    } catch(e){
        console.error("Error in Group Chat",e);
    }
}


export const ClearChat = (socket:any, mesg:any) => {
    console.log("Clear Chat Message --->", mesg);
}


export const convertMentionToObject = (array: any) => {
    const initialValue = {};
    return array.reduce((obj: any, item: any) => {
        return {
            ...obj,
            ['s' + item]: 1
        };
    }, initialValue);
};


export const historyGroupList = (socket: any, chatRecord: any) => {
    try {
    let { archiveID, messageList, scrollPos }: any = store.getState().chatSocketReducerState;
    //let { userdetails }: LoginState = store.getState().loginReducer;
     let { recentChatList }: any = store.getState().chatSocketRecentReducerState;
    let contactObject: any = store.getState().contactReducer;
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    let direction = '';
    const archiveMessageArray = chatRecord.map((message: any) => {
        const fromUser = parseInt(message.from);
        const unixTimeStamp = moment().valueOf();
        // recentChatList["con"+message.chatId].unreadCount = recentChatList[message.chatId].unreadCount -1;
        if (message && chatWindowReducer?.chatWindowDetails?.team_id && fromUser !== parseInt(userInfo().fromID)) {
            // console.log("FROM ID --->",parseInt(userInfo().fromID));
            if (parseInt(userInfo().fromID) && (_.isUndefined(message?.deliveryreport?.["s"+parseInt(userInfo().fromID)])===true)) {
                newTagUnread(message);
                socket.groupChatDelivered(message.id, 2, unixTimeStamp, message.from.toString(), message.chatId, message.chatId);
            } 
            if (parseInt(message.chatId) === parseInt(chatWindowReducer?.chatWindowDetails?.team_id)) {
               
                if (_.isUndefined(message?.readreport?.["s"+parseInt(userInfo().fromID)])===true) {
                    socket.groupChatReadStatus(message.id, 2, unixTimeStamp, message.from.toString(), message.chatId, message.chatId);
                    newTagUnread(message);
                } else {
                    if(Array.isArray(chatWindowReducer?.newTagMessage) && chatWindowReducer?.newTagMessage?.length > 0){
                  store.dispatch({
                      type: Types.NEW_TAG_MESSAGE,
                      payload:{
                          newTagMessage: []
                      }
                  });
                }
                }
            }
        }

        if (fromUser !== parseInt(userInfo().fromID)) {
            direction = "IN";
        } else {
            direction = "OUT";
        }

        message.direction = direction;
        message.fromcaller_details = contactObject.workContactsnew[fromUser];
        return message;
    });
    if (archiveMessageArray.length > 0) {
        if(chatWindowReducer.clearChatMsg !== ""){
            let value:any = _.last(archiveMessageArray);
            let lastMesgText = value?.message?.messageType === "TEXT" ? value?.message.body :
            value?.message?.messageType === "FILE" && videoFormat.indexOf(value?.message?.body?.fileType) !== -1
                ? "Video" :
                value?.message?.messageType === "FILE" && videoFormat.indexOf(value?.message?.body?.fileType) === -1 ? "Shared a file" :  value?.message?.messageType === "IMAGE" && value?.message?.body?.fileType?.includes("gif")
        ? "GIF"
        : value?.message?.messageType === "IMAGE" ? "IMAGE" :
        value?.message?.messageType === "NOTE" ? "Shared a notes" : value?.message?.messageType === "TASK" ?
                "Shared a task" : value?.message?.messageType === "EVENTS" ? "Shared a event" : value?.message?.messageType === "BROADCAST" ? "finalString" : "";
       
            if (recentChatList["con" + value.chatId]) {
                recentChatList["con" + value.chatId].lastmessage = value;
                recentChatList["con" + value.chatId].lastmsgText = lastMesgText;
            }
            store.dispatch({
                type: Types.CHAT_CLEAR_MESSAGE,
                payload: {
                  clearChatMsg:''
                }
            })
        }
    }
   
    if(chatWindowReducer.clearChatMsg !== '' && archiveMessageArray.length === 0){
        let clrValue:any = parseInt(chatWindowReducer?.chatWindowDetails?.team_id);
        if(recentChatList["con" + clrValue]){
            recentChatList["con" + clrValue].lastmessage= '';
            recentChatList["con" + clrValue].lastmsgText = '';
        store.dispatch({
            type: actionTypes.RECENT_MESSAGE_LIST,
            payload: {
                recentChatList: recentChatList,
                recentLoading: true
            }
        });
        store.dispatch({
            type: Types.CHAT_CLEAR_MESSAGE,
            payload: {
              clearChatMsg:''
            }
          })
        }
    }
    // console.log(archiveID,"<---- Archive ID ---->"+archiveID+"Message Team List ---->",archiveMessageArray);
    store.dispatch({
        type: actionTypes.MESSAGE_LIST,
        payload: {
            messageList: archiveID ? [...archiveMessageArray, ...messageList] : [...archiveMessageArray],
            messageLoading: archiveID ? false : false,
            scrollPos: scrollPos,
            archiveID: archiveID
        }
    });
    } catch(e){
        console.error("Error in History Group Chat",e);
    }
}
export const newMembersGroup = (socket: any, newMembers: any) => {
    try {
    if (newMembers.data) {
        let chatWindowAllDetails: chatwindowDetails = store.getState().chatWindowReducer;
        let contactDetailWindowreducer: contactwindowDetails = store.getState().contactWindowReducer;
        let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
        let contactRed = store.getState().contactReducer;
        let { teamContacsnew, allContacs, workContactsnew }: any = contactRed;

        if (chatWindowAllDetails.isChatWindow && chatWindowAllDetails.chatWindowDetails?.team_id === newMembers?.data?.team_id) {
            let teamMemberArray: any = newMembers.data.team_members.split(",");
           
            let list = teamMemberArray.map((value: any, index: any) => {
                let trimmedValue = value.trim();
                return workContactsnew[trimmedValue] || loggedUserDetails });
        
            chatWindowAllDetails.chatWindowDetails.team_members = newMembers.data.team_members
            chatWindowAllDetails.chatWindowDetails.teammembersdetails = list;

            openChatWindowRedux(chatWindowAllDetails.chatWindowDetails);
        }



        let teamKey: any = newMembers?.data?.team_id_prefix + newMembers?.data?.team_id;
        teamContacsnew[teamKey] = newMembers?.data;
        let particularIndex: any = allContacs && allContacs?.findIndex((elem: any) => (elem.team_id === newMembers.data?.team_id));
        if (particularIndex !== -1) {
            allContacs[particularIndex] = newMembers?.data;

        }

        setTeamContactNew(teamContacsnew, true);
        setAllContact(allContacs);
        openContactWindowRedux(contactDetailWindowreducer.isContactWindow, chatWindowAllDetails.chatWindowDetails, false)


    } else {
        toastInformation("Something went wrong", "failure");
    }
    } catch(e){
        console.error("Error in New members Group",e);
    }

}
export const removeMembersGroup = (socket: any, RemoveMembers: any) => {
    try {
    const RemoveMembersInfo: any = RemoveMembers.data;
    if (RemoveMembersInfo) {
        let { isChatWindow, chatWindowDetails }: chatwindowDetails = store.getState().chatWindowReducer;
        if (isChatWindow && chatWindowDetails?.team_id === RemoveMembersInfo?.team_id) {
            let memberArray = chatWindowDetails?.teammembersdetails
            let teamMemberArray: any = RemoveMembersInfo.team_members.split(",")
                .map((contactdata: any) => contactdata.trim());
            memberArray = memberArray.filter((elem: any) => teamMemberArray.includes(elem.sip_login_id.toString().trim()));
            chatWindowDetails.team_members = RemoveMembersInfo.team_members;
            chatWindowDetails.teammembersdetails = memberArray;
            openChatWindowRedux(chatWindowDetails);
        }
        let contactRed = store.getState().contactReducer;
        let { teamContacsnew, allContacs }: any = contactRed;
        let teamKey: any = RemoveMembersInfo.team_id_prefix + RemoveMembersInfo.team_id;
        teamContacsnew[teamKey] = RemoveMembersInfo;
        let particularIndex: any = allContacs && allContacs?.findIndex((elem: any) => (elem.team_id === RemoveMembersInfo.team_id));
        if (particularIndex !== -1) {
            allContacs[particularIndex] = RemoveMembersInfo;
        }
        setTeamContactNew(teamContacsnew, true)
        setAllContact(allContacs);

    } else {
        toastInformation("Something went wrong", "failure");
    }
    } catch(e){
        console.error("Error in Remove members Group",e);
    }
}

export const teamAdminChange = (socket: any, roleTypeData: any) => {
    try {
    if (roleTypeData.status === "success") {

        let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
        let contactReduceVal = store.getState().contactReducer;
        let { teamContacsnew, allContacs }: any = contactReduceVal;

        let teamNameKey: any = "con" + roleTypeData?.data?.teamId;
        teamContacsnew[teamNameKey] = roleTypeData.data;
        let particularIndex: any = allContacs && allContacs?.findIndex((elem: any) => (elem.team_id === roleTypeData.data?.team_id));


        if (particularIndex !== -1) {
            allContacs[particularIndex] = roleTypeData.data;
        }
        if (chatWindowReducer.isChatWindow && chatWindowReducer.chatWindowDetails?.team_id === roleTypeData?.data?.team_id) {
            let newData = { ...roleTypeData.data };
            newData['teammembersdetails'] = chatWindowReducer.chatWindowDetails?.teammembersdetails;
            openChatWindowRedux(newData);
        }
        setTeamContactNew(teamContacsnew, true);
        setAllContact(allContacs);
    }
    } catch(e){
        console.error("Error in Admin Change",e);
    }
}


export const leaveMembersGroup = (socket: any, leaveMembers: any) => {
    try {
    let leaveMemberInfo = leaveMembers.data;
    if (leaveMemberInfo) {
        let chatWindowAllDetails: chatwindowDetails = store.getState().chatWindowReducer;
        let contactRed = store.getState().contactReducer;
        //let contactDetailWindowreducer: contactwindowDetails = store.getState().contactWindowReducer;
        let { teamContacsnew, allContacs }: any = contactRed;

        if (chatWindowAllDetails.isChatWindow && chatWindowAllDetails.chatWindowDetails.team_id === leaveMemberInfo?.team_id ) {
            let memberArray = chatWindowAllDetails.chatWindowDetails?.teammembersdetails;
            let teamMemberArray: any = leaveMemberInfo.team_members!== null ? leaveMemberInfo.team_members.split(",")
                .map((contactdata: any) => contactdata.trim()) : [];
            memberArray = memberArray.filter((elem: any) => teamMemberArray.includes(elem.sip_login_id.toString().trim()));
            chatWindowAllDetails.chatWindowDetails.team_members = leaveMemberInfo.team_members;
            chatWindowAllDetails.chatWindowDetails.leaveTeamMembers = leaveMemberInfo.leaveTeamMembers;
            chatWindowAllDetails.chatWindowDetails.teammembersdetails = memberArray;
            chatWindowAllDetails.chatWindowDetails.admin_members = leaveMemberInfo.admin_members;
            openChatWindowRedux(chatWindowAllDetails.chatWindowDetails)
            //  if (chatWindowAllDetails.isChatWindow  && chatWindowAllDetails.chatWindowDetails?.team_id) {
            //     console.log("other side-----");
            // openChatWindowRedux(chatWindowAllDetails.isChatWindow,adminMemberAdded,chatWindowAllDetails.isMySpace)
            // }


        }


        let teamKey: any = leaveMemberInfo?.team_id_prefix + leaveMemberInfo?.team_id;
        teamContacsnew[teamKey] = leaveMemberInfo;

        let particularIndex: any = allContacs && allContacs?.findIndex((elem: any) => (elem.team_id === leaveMemberInfo?.team_id));
        if (particularIndex !== -1) {
            allContacs[particularIndex] = leaveMemberInfo;
        }

        setAllContact(allContacs);
        setTeamContactNew(teamContacsnew, true);

    } else {
        toastInformation("Something went wrong", "failure");
    }
    } catch(e){
        console.error("Error in Leave members",e);
    }
}

export const updateGroupDetailsInfo = (socket: any, updatedTeamInfo: any) => {
    try {
    let contactAllReducer = store.getState().contactReducer;
    let { teamContacsnew, allContacs }: any = contactAllReducer;
    let contactDetailWindowreducer: contactwindowDetails = store.getState().contactWindowReducer;
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    if (updatedTeamInfo.data) {
        let teamUpdatedInfo: any = chatWindowReducer?.chatWindowDetails;
        teamUpdatedInfo = {
            ...teamUpdatedInfo, team_name: updatedTeamInfo.data?.team_name,
            description: updatedTeamInfo.data?.description,
            //team_name: updatedTeamInfo.data?.team_name,
            profile_image_url: updatedTeamInfo.data?.profile_image_url
        }
        let teamKey = "con" + updatedTeamInfo.data?.team_id;
        let particularTeamData = teamContacsnew[teamKey];

        particularTeamData =
        {
            ...particularTeamData, team_name: updatedTeamInfo.data?.team_name,
            description: updatedTeamInfo.data?.description,
            profile_image_url: updatedTeamInfo.data?.profile_image_url
            //caller_id: updatedTeamInfo.data?.team_name

        }
        teamContacsnew[teamKey] = particularTeamData;
        allContacs?.map((element: any) => {
            if (element.team_id === updatedTeamInfo.data?.team_id) {
                element.team_name = updatedTeamInfo.data?.team_name;
                element.description = updatedTeamInfo.data?.description;
                element.profile_image_url = updatedTeamInfo.data?.profile_image_url;
                return element;
            }
        });
        if (chatWindowReducer.isChatWindow && chatWindowReducer.chatWindowDetails?.team_id=== updatedTeamInfo?.data?.team_id) {
            openChatWindowRedux(teamUpdatedInfo);
        }
        setAllContact(allContacs);
        setTeamContactNew(teamContacsnew, true);
        openContactWindowRedux(contactDetailWindowreducer.isContactWindow, teamUpdatedInfo, false)

        // toastInformation("Team Details Updated", "success");
    }
    else {
        toastInformation(updatedTeamInfo.status, "failure");
    }
    } catch(e){
        console.error("Error in Group Update",e);
    }
};